import { render, staticRenderFns } from "./QMonthlyNewAgentChart.vue?vue&type=template&id=8b8089a6&scoped=true&"
import script from "./QMonthlyNewAgentChart.vue?vue&type=script&lang=js&"
export * from "./QMonthlyNewAgentChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8089a6",
  null
  
)

export default component.exports